import './style.scss';

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateUser } from '../login/actions';
import AccountDetails from './accountDetails';
import Payment from './payment';
import Promos from './promos';
import { NarrowContainer } from 'scy/layouts';
import { pageContainer } from 'scy/utils.mod.scss';
import RoundUp from '../roundUp';
import AccountSection from './AccountSection';

function AccountPage() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.login.user);
  const isVerified = user && user.mobileVerified;

  return (
    <NarrowContainer className={pageContainer}>
      <AccountSection title="Account Details">
        <AccountDetails
          user={user}
          updateUser={data => dispatch(updateUser(data))}
        />
      </AccountSection>
      {isVerified && (
        <AccountSection title="Payment Methods">
          <Payment />
        </AccountSection>
      )}
      <AccountSection title="round up for change">
        <RoundUp updateUser={data => dispatch(updateUser(data))} />
      </AccountSection>
      <AccountSection title="Promos & Gift Cards">
        <Promos />
      </AccountSection>
    </NarrowContainer>
  );
}

export default AccountPage;
